import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-cancel-charter-dialog',
  templateUrl: './customer-sign-agreement-dialog.component.html',
  styleUrls: ['./customer-sign-agreement-dialog.component.scss'],
})
export class CustomerSignAgreementDialogComponent implements OnInit {
  name: string;
  affirmativeText: string;
  negativeText: string;

  signatureAdopted = false;

  constructor(
    private dialogRef: MatDialogRef<CustomerSignAgreementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.name = this.data.name;
    this.negativeText = 'Cancel';
    this.affirmativeText = 'Sign charter agreement';
  }

  ngOnInit() {}

  checkboxChange(val: any): void {
    this.signatureAdopted = val.checked;
  }

  closeDialog(userResponse: boolean) {
    this.dialogRef.close(userResponse);
  }
}
